import React from "react";
import {
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Switch,
  IconButton,
  Button,
} from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PremiumInput from "../../../../Components/Inputs/PremiumInput";
import CustomPersianDatePicker from "../../../../Components/CustomPersianDatePicker";

export default function WorkExperienceSection({ onAdd, onRemove, formik }) {
  const experiences = formik?.values?.work_experiences ?? [];

  return (
    <Box sx={{ mt: 3, p: 2, bgcolor: "rgba(0,0,0,0.2)", borderRadius: 2 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WorkIcon sx={{ color: "#00ffcc" }} />
          <Typography sx={{ color: "#fff", fontWeight: 700 }}>
            سوابق کاری (اختیاری)
          </Typography>
        </Box>
      </Box>

      {experiences?.length === 0 ? (
        <Box
          sx={{
            p: 3,
            mb: 2,
            bgcolor: "rgba(255,255,255,0.03)",
            borderRadius: 2,
            border: "1px dashed rgba(255,255,255,0.1)",
            textAlign: "center",
          }}
        >
          <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: 14 }}>
            سابقه کاری ثبت نشده است. در صورت داشتن سابقه کار، روی دکمه زیر کلیک
            کنید.
          </Typography>
        </Box>
      ) : (
        experiences.map((exp, index) => (
          <Box
            key={index}
            sx={{
              mb: 3,
              p: 2,
              bgcolor: "rgba(255,255,255,0.05)",
              borderRadius: 2,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 6 }}>
                <PremiumInput
                  name={`work_experiences[${index}].company_name`}
                  label="نام شرکت"
                  isRequired
                  formik={formik}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <PremiumInput
                  name={`work_experiences[${index}].job_title`}
                  label="سمت شغلی"
                  isRequired
                  formik={formik}
                />
              </Grid>

              <Grid size={{ xs: 6, md: 3 }}>
                <CustomPersianDatePicker
                  name={`work_experiences[${index}].start_date`}
                  label="تاریخ شروع"
                  placeholder="انتخاب تاریخ"
                  isRequired
                  formik={formik}
                />
              </Grid>

              <Grid size={{ xs: 6, md: 3 }}>
                <CustomPersianDatePicker
                  name={`work_experiences[${index}].end_date`}
                  label="تاریخ پایان"
                  placeholder="انتخاب تاریخ"
                  isRequired={!exp?.is_current_job}
                  disabled={Boolean(exp?.is_current_job)}
                  formik={formik}
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(exp?.is_current_job)}
                      onChange={(e) => {
                        const checked = Boolean(e?.target?.checked);
                        formik?.setFieldValue(
                          `work_experiences[${index}].is_current_job`,
                          checked,
                        );
                        if (checked) {
                          formik?.setFieldValue(
                            `work_experiences[${index}].end_date`,
                            null,
                          );
                        }
                      }}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#00ffcc",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#00ffcc",
                          },
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ color: "rgba(255,255,255,0.7)" }}>
                      هم‌اکنون مشغول هستم
                    </Typography>
                  }
                />
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <PremiumInput
                  name={`work_experiences[${index}].reason_for_leaving`}
                  label="علت ترک کار (اختیاری)"
                  formik={formik}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
              <IconButton
                onClick={() => onRemove?.(index)}
                color="error"
                sx={{
                  border: "1px solid rgba(244, 67, 54, 0.5)",
                  borderRadius: "8px",
                  "&:hover": { bgcolor: "rgba(244, 67, 54, 0.1)" },
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        ))
      )}

      <Button
        variant="outlined"
        startIcon={<AddIcon sx={{ ml: "8px" }} />}
        onClick={onAdd}
        sx={{
          color: "#00ffcc",
          borderColor: "rgba(0,255,204,0.5)",
          borderRadius: "12px",
          "&:hover": {
            bgcolor: "rgba(0,255,204,0.1)",
            borderColor: "#00ffcc",
          },
        }}
      >
        افزودن سابقه کاری
      </Button>
    </Box>
  );
}
